__turbopack_context__.v({
  "footer": "CheckoutOutOfStockFormFooter-module-scss-module__iKbjxW__footer",
});
